import React, { useState } from 'react';
import ChartPanel from './ChartPanel';

const number = (value, digits = 2) => value == null ? '—' : Number(value).toLocaleString('en-IN', { minimumFractionDigits: digits, maximumFractionDigits: digits });

const ORDER_COLUMNS = 8;

const OrderRow = ({ order, busy, expanded, onToggle, onFill, onVoid }) => {
  const stopRowToggle = (event) => event.stopPropagation();
  const markers = [
    { price: order.entry_price, label: `Entry ₹${number(order.entry_price)}`, kind: 'entry' },
    ...(order.stop_price != null ? [{ price: order.stop_price, label: `Stop ₹${number(order.stop_price)}`, kind: 'stop' }] : []),
  ];

  return <>
    <tr className={expanded ? 'position-expanded' : ''} onClick={onToggle} title="Click to show chart">
      <td className="symbol position-symbol-cell">{order.symbol}<a href={`https://www.screener.in/company/${encodeURIComponent(order.symbol)}/`} target="_blank" rel="noreferrer" onClick={stopRowToggle}>Screener</a></td>
      <td>{order.broker_name}</td>
      <td className="number">{number(order.quantity, 0)}</td>
      <td className="number">{number(order.entry_price)}</td>
      <td className="number">{number(order.quantity * order.entry_price, 0)}</td>
      <td>{order.stop_price != null ? number(order.stop_price) : '—'}</td>
      <td onClick={stopRowToggle}>
        <input
          type="checkbox"
          checked={false}
          disabled={busy}
          onChange={() => onFill(order.id)}
          aria-label={`Mark ${order.symbol} order as filled`}
          title="Currently unfilled - tick once the broker has filled this order"
        />
      </td>
      <td onClick={stopRowToggle}><button type="button" className="void-trade" disabled={busy} onClick={() => onVoid(order.id)}>Void</button></td>
    </tr>
    {expanded && <tr className="position-chart-row"><td colSpan={ORDER_COLUMNS}>
      <div className="position-chart" onClick={stopRowToggle}>
        <header><strong>{order.symbol} chart</strong><span>Pending entry and stop are shown on the chart.</span></header>
        <ChartPanel link={order.symbol} markers={markers} />
      </div>
    </td></tr>}
  </>;
};

const OrdersPage = ({ state, busy, error, onFill, onVoid }) => {
  const orders = state.orders || [];
  const [expandedId, setExpandedId] = useState(null);

  return (
    <main className="journal-page">
      <section className="journal-card">
        <header><div><strong>Orders</strong><span>{orders.length} pending · click a row for chart</span></div></header>
        {error && <div className="table-message error">{error}</div>}
        {orders.length === 0
          ? <div className="journal-empty">No pending orders</div>
          : (
            <div className="journal-scroll">
              <table className="journal-table orders-table">
                <thead><tr><th>Stock</th><th>Broker</th><th className="number">Qty</th><th className="number">Entry</th><th className="number">Total</th><th>Stop</th><th className="not-sortable">Unfilled</th><th className="not-sortable"></th></tr></thead>
                <tbody>
                  {orders.map((order) => <OrderRow key={order.id} order={order} busy={busy} expanded={expandedId === order.id} onToggle={() => setExpandedId((id) => id === order.id ? null : order.id)} onFill={onFill} onVoid={onVoid} />)}
                </tbody>
              </table>
            </div>
          )}
      </section>
    </main>
  );
};

export default OrdersPage;
